// ** React Imports
import { useState, SyntheticEvent, Fragment } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Menu from '@mui/material/Menu'
import Badge from '@mui/material/Badge'
import Avatar from '@mui/material/Avatar'
import Divider from '@mui/material/Divider'
import MenuItem from '@mui/material/MenuItem'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

// ** Icon Imports
import Icon from 'src/@core/components/icon'

// ** Context
import { useAuth } from 'src/hooks/useAuth'

// ** Type Imports
import { Settings } from 'src/@core/context/settingsContext'
import { useNavigate } from 'react-router-dom'
import { userStorage } from "../../../../utils/localStorage";
import {useTranslation} from "react-i18next";
import ChangePasswordDialog from "./components/ChangePasswordDialog";

interface Props {
    settings: Settings
}

// ** Styled Components
const BadgeContentSpan = styled('span')(({ theme }) => ({
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: theme.palette.success.main,
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`
}))

const UserDropdown = (props: Props) => {
    const { t } = useTranslation();

    // const fullName = userStorage.getFullName();
    const { fullName, cargo } = userStorage.get()
    const inicialesNombreApellido = fullName.split(" ").map(n => n[0]).join("")

    // ** Props
    const { settings } = props

    // ** States
    const [anchorEl, setAnchorEl] = useState<Element | null>(null);
    const [showChangePassword, setShowChangePassword] = useState<boolean>(false);

    // ** Hooks
    const navigate = useNavigate()
    const { logout } = useAuth()

    // ** Vars
    const { direction } = settings

    const handleDropdownOpen = (event: SyntheticEvent) => {
        setAnchorEl(event.currentTarget)
    }

    const handleDropdownClose = (url?: string) => {
        if (url) {
            navigate(url)
        }
        setAnchorEl(null)
    }

    const styles = {
        py: 2,
        px: 4,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        color: 'text.primary',
        textDecoration: 'none',
        '& svg': {
            mr: 2,
            fontSize: '1.375rem',
            color: 'text.primary'
        }
    }

    const handleLogout = () => {
        userStorage.removeFromStorage();
        navigate('/login');
        logout()
        handleDropdownClose()
    }
    
    const openChangePasswordDialog = () => {
        setShowChangePassword(true);
        setAnchorEl(null);
    }
    
    const closeChangePasswordDialog = () => setShowChangePassword(false);
    
    return (
        <Fragment>
            <Badge
                overlap='circular'
                onClick={handleDropdownOpen}
                sx={{ ml: 2, cursor: 'pointer' }}
                badgeContent={<BadgeContentSpan />}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
            >
                <Avatar
                    alt={fullName}
                    onClick={handleDropdownOpen}
                    sx={{ width: 40, height: 40 }}
                >{inicialesNombreApellido}</Avatar>
            </Badge>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => handleDropdownClose()}
                sx={{ '& .MuiMenu-paper': { width: 230, mt: 4 } }}
                anchorOrigin={{ vertical: 'bottom', horizontal: direction === 'ltr' ? 'right' : 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: direction === 'ltr' ? 'right' : 'left' }}
            >
                <Box sx={{ pt: 2, pb: 3, px: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Badge
                            overlap='circular'
                            badgeContent={<BadgeContentSpan />}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right'
                            }}
                        >
                            {/* <Avatar alt={nombre + apellido} src='/images/avatars/1.png' sx={{ width: '2.5rem', height: '2.5rem' }} /> */}
                            <Avatar alt={fullName} sx={{ width: '2.5rem', height: '2.5rem' }}>{inicialesNombreApellido}</Avatar>
                        </Badge>
                        <Box sx={{ display: 'flex', ml: 3, alignItems: 'flex-start', flexDirection: 'column' }}>
                            <Typography sx={{ fontWeight: 600 }}>{fullName}</Typography>
                            <Typography variant='body2' sx={{ fontSize: '0.8rem', color: 'text.disabled' }}>
                                {cargo}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                {/* <Divider sx={{ mt: '0 !important' }} />
                <MenuItem sx={{ p: 0 }} onClick={() => handleDropdownClose()}>
                    <Box sx={styles}>
                        <Icon icon='mdi:account-outline' />
                        Profile
                    </Box>
                </MenuItem>
                <MenuItem sx={{ p: 0 }} onClick={() => handleDropdownClose()}>
                    <Box sx={styles}>
                        <Icon icon='mdi:email-outline' />
                        Inbox
                    </Box>
                </MenuItem>
                <MenuItem sx={{ p: 0 }} onClick={() => handleDropdownClose()}>
                    <Box sx={styles}>
                        <Icon icon='mdi:message-outline' />
                        Chat
                    </Box>
                </MenuItem>
                <Divider />
                <MenuItem sx={{ p: 0 }} onClick={() => handleDropdownClose()}>
                    <Box sx={styles}>
                        <Icon icon='mdi:cog-outline' />
                        Settings
                    </Box>
                </MenuItem>
                <MenuItem sx={{ p: 0 }} onClick={() => handleDropdownClose()}>
                    <Box sx={styles}>
                        <Icon icon='mdi:currency-usd' />
                        Pricing
                    </Box>
                </MenuItem>
                <MenuItem sx={{ p: 0 }} onClick={() => handleDropdownClose()}>
                    <Box sx={styles}>
                        <Icon icon='mdi:help-circle-outline' />
                        FAQ
                    </Box>
                </MenuItem> */}
                <MenuItem
                    onClick={openChangePasswordDialog}
                    sx={{ py: 2, '& svg': { mr: 2, fontSize: '1.375rem', color: 'text.primary' } }}
                >
                    <Icon icon='mdi:lock-reset' />
                    {t("CambiarContrasenia")}
                </MenuItem>
                <Divider />
                <MenuItem
                    onClick={handleLogout}
                    sx={{ py: 2, '& svg': { mr: 2, fontSize: '1.375rem', color: 'text.primary' } }}
                >
                    <Icon icon='mdi:logout-variant' />
                    Logout
                </MenuItem>
            </Menu>
            
            <ChangePasswordDialog open={showChangePassword}
                                  onClose={closeChangePasswordDialog}
            />
        </Fragment>
    )
}

export default UserDropdown
